import { useEffect } from 'react';
import NProgress from 'nprogress';
import { Box } from './styles';

function SuspenseLoader({ blocked, statusMessage }) {
  useEffect(() => {
    NProgress.start();

    return () => {
      NProgress.done();
    };
  }, []);

  return (
    <Box blocked={blocked}>
      <div className="lds-dual-ring" />
      {statusMessage && <p className="status-message">{statusMessage}</p>}
    </Box>
  );
}

export default SuspenseLoader;
